<template>
  <div class="input-group">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="p-t-0 p-b-0">
        <v-radio-group v-model="property.type" grow dense hide-details>
          <v-radio class="radio-top" value="page">
            <template v-slot:label>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="d-flex">
                  <v-select
                    class="m-auto"
                    v-model="property.page"
                    :items="tabFilter"
                    item-text="name"
                    item-value="id"
                    label="Go to page"
                    @change="changePage"
                    dense
                    hide-details
                  ></v-select>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        class="m-l-10"
                        :disabled="!property.page"
                        @click="goToPage(property.page)"
                      >
                        fa-arrow-up-right-from-square
                      </v-icon>
                    </template>
                    <span>Open page</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12" class="p-t-0">
                  <div class="m-b-15">Start at</div>
                  <v-radio-group
                    v-model="property.is_custom_component"
                    dense
                    hide-details
                    class="m-l-15"
                    :disabled="property.type !== 'page'"
                  >
                    <v-radio :value="false" class="margin-radio">
                      <template v-slot:label>
                        <div class="display-flex font-size-body">
                          <div class="m-auto width100px">
                            Begin of page
                          </div>
                        </div>
                      </template>
                    </v-radio>
                    <v-radio :value="true" class="margin-radio">
                      <template v-slot:label>
                        <div class="font-size-body width100">
                          <v-select
                            class="width100"
                            v-model="property.component"
                            :items="itemFilter"
                            item-text="name"
                            item-value="id"
                            label="Jump to component"
                            dense
                            hide-details
                          >
                            <template v-slot:selection="{ attrs, item }">
                              <div class="d-flex align-center">
                                <div class="width25px text-center m-r-5">
                                  <v-icon small>{{ item.icon }}</v-icon>
                                </div>
                                {{ item.name }}
                              </div>
                            </template>
                            <template v-slot:item="{ index, item }">
                              <v-list-item-content class="list-icon">
                                <div class="d-flex">
                                  <div class="width25px text-center m-r-5">
                                    <v-icon small>{{ item.icon }}</v-icon>
                                  </div>
                                  {{ item.name }}
                                </div>
                              </v-list-item-content>
                            </template>
                          </v-select>
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </template>
          </v-radio>

          <v-radio value="page_name" class="radio-top">
            <template v-slot:label>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="d-flex">
                  <v-text-field
                    v-model="property.page_name"
                    label="Go to page name"
                    dense
                    hide-details
                    @keyup.down="pressDown"
                    @keyup.up="pressUp"
                    @keydown.enter="onEnter"
                    @keydown.tab="pressTab"
                  >
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                  class="d-flex p-t-0 p-b-0"
                >
                  <!-- === use for Intellisense  ===-->
                  <intellisense-component
                    :input="property.page_name"
                    :drawFlowItems="drawFlowItems"
                    :property="'page_name'"
                    :apiForIntellisense="apiForIntellisense"
                    :start="start"
                    :eventKey="eventKey"
                    @clearSelected="clearSelected"
                    @updateInputFromIntellisense="updateInputFromIntellisense"
                  />
                  <!-- === use for Intellisense ===-->
                </v-col>
              </v-row>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>

    <hr class="note-divider" />
    <note-component :node="node" />
  </div>
</template>

<script>
import _ from 'lodash'

import NoteComponent from '../../../components/note'
// === use for Intellisense ===
import IntellisenseComponent from '../../../components/intellisense'
// === use for Intellisense ===

export default {
  props: {
    node: Object,
    tabs: Array,
    currentTab: String,
    drawFlowItems: Object,
    // === use for Intellisense ===
    apiForIntellisense: Object
    // === use for Intellisense ===
  },
  components: {
    NoteComponent,
    // === use for Intellisense ===
    IntellisenseComponent
    // === use for Intellisense ===
  },
  data() {
    return {
      property: {},
      tabFilter: [],
      itemFilter: [],
      //=== use for Intellisense ===-->
      isOpenIntellisense: false,
      start: -1,
      isKeyTab: false,
      eventKey: ''
      //=== use for Intellisense ===-->
    }
  },
  created() {
    this.property = this.node.property

    if (this.property.is_custom_component === undefined) {
      this.property.is_custom_component = false
      this.property.component = ''
    }
    if (this.property.type === undefined) {
      this.property.type = 'page'
    }

    const tabFilter = _.filter(
      this.tabs,
      o => o.name !== this.currentTab // o.name !== 'Home' && o.name !== this.currentTab
    )

    this.tabFilter = _.sortBy(tabFilter, [
      function(o) {
        return o.name.toLowerCase()
      }
    ])

    for (const property of [
      'type',
      'page',
      'is_custom_component',
      'component',
      'page_name'
    ]) {
      this.$watch(
        `property.${property}`, //what you want to watch
        (newVal, oldVal) => {
          this.getPageName()
        }
      )
    }
  },
  watch: {
    'property.page': {
      handler() {
        // find value for component
        const item = _.find(this.tabs, { id: this.property.page })
        if (item) {
          this.itemFilter = []

          if (this.drawFlowItems[item.name]) {
            const data = this.drawFlowItems[item.name].data
            const items = []
            for (const index in data) {
              items.push({
                id: data[index].id,
                name: data[index].data.name,
                type: data[index].data.node,
                icon: data[index].data.ui ? data[index].data.ui.icon : ''
              })
            }

            const itemFilter = _.filter(items, o => {
              return this.$nodeNoJump.indexOf(o.type) === -1
            })
            this.itemFilter = _.sortBy(itemFilter, [
              function(o) {
                return o.name.toLowerCase()
              }
            ])
          }
        }
      }
    }
  },
  methods: {
    changePage() {
      this.property.is_custom_component = false
      this.property.component = ''
    },
    goToPage(pageId) {
      this.$emit('goToPage', pageId)
    },
    getPageName() {
      if (this.property.type === 'page_name') {
        this.node.name = this.property.page_name
      } else {
        const item = _.find(this.tabs, { id: this.property.page })
        if (item) {
          if (this.property.is_custom_component) {
            const component = _.find(this.itemFilter, {
              id: this.property.component
            })
            if (component) this.node.name = `${item.name} / ${component.name}`
          } else {
            this.node.name = item.name
          }
        }
      }
    },
    //=== use for Intellisense ===-->
    pressDown() {
      this.start += 1
      this.eventKey = 'keydown'
    },
    pressUp() {
      this.start -= 1
      this.eventKey = 'keyup'
    },
    pressTab() {
      this.isKeyTab = true
      this.start = -1
    },
    onEnter(e) {
      if (e.keyCode === 13 && this.start > -1) {
        this.eventKey = 'enter'
        this.start = -1
        e.preventDefault()
      }
      this.eventKey = 'enter'
      this.start = -1
    },
    clearSelected() {
      this.start = -1
    },
    updateInputFromIntellisense(property, data) {
      if (property == 'page_name') {
        this.property.page_name = data
      }
    }
    //=== use for Intellisense ===-->
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-radio.radio-top {
  align-items: baseline !important;
}
</style>
